<template>
  <div style="margin-top: 2px">
    <div :class="['h-table', isNeedCard ? 'h-card' : '']">
      <!------顶部按钮区域------>
      <div class="top-buttons">
        <span v-for="(item, index) in topButtons" :key="index" style="margin-right: 8px">
          <span v-if="item.mode">
            <el-button size="small" v-if="item.mode.includes(mode)" type="primary" plain :icon="item.icon"
              @click="emitMethod(item.key, item.params)">{{ item.name }}</el-button>
          </span>
          <span v-else>
            <span v-if="item.toolTips">
              <el-tooltip :content="item.toolTips" placement="top">
                <el-button size="small" :type="item.type || 'primary'" plain :icon="item.icon"
                  @click="emitMethod(item.key, item.params)">{{ item.name }}</el-button>
              </el-tooltip>
            </span>
            <span v-else>
              <el-button size="small" :type="item.type || 'primary'" plain :icon="item.icon"
                @click="emitMethod(item.key, item.params)">{{ item.name }}</el-button>
            </span>
          </span>
        </span>
      </div>
      <div class="right-buttons" v-if="showRightButtons">
        <el-tooltip class="item" effect="dark" content="显隐列" placement="top">
          <el-button circle icon="Menu" @click="showDrawer" />
        </el-tooltip>
      </div>
      <!-------表格区域-------------->
      <el-table v-loading="loading" element-loading-text="数据加载中..." :data="workTodoData" style="width: 100%"
        :max-height="tableHeight" border :stripe="false" :show-summary="isShowSummary"
        :header-cell-style="headerCellStyle" :cell-style="cellStyle" @selection-change="handleSelectionChange"
        :border="false">
        <el-table-column v-if="isMultify" type="selection" width="40" />

        <el-table-column type="index" label="序号" width="60" align="center" fixed v-if="tableIndex">
          <template #default="scope">
            {{ (queryTable.page - 1) * queryTable.size + scope.$index + 1 }}
          </template>
        </el-table-column>
        <template v-for="(item, index) in newTableProps">
          <el-table-column v-if="item.formatValue" :key="index" :label="item.labelName" align="center"
            :min-width="item.width || tableSetThWidth(item, workTodoData)" :fixed="item.fix"
            :formatter="item.formatValue" :prop="item.prop" :width="item.width" :show-overflow-tooltip="false" />
          <el-table-column v-else :key="index + item.labelName" :label="item.labelName" align="center"
            :min-width="item.width || tableSetThWidth(item, workTodoData)" :max-width="item.maxWidth" :prop="item.prop"
            :fixed="item.fix" :width="item.width" :show-overflow-tooltip="false">
            <template #default="{ row }">
              <el-link type="primary" @click="handleClick(row, item.prop)" v-if="item.alink" class="alink-color">{{
                row[item.prop] }}</el-link>
              <div v-else-if="item.input">
                <el-input-number style="width: 150px" type="primary" :min="0" :max="999"
                  @change="handleBlur(row, item.prop)" v-model="row[item.prop]" />
              </div>

              <span v-else>
                {{ row[item.prop] }}
              </span>
            </template>
          </el-table-column>
        </template>
        <!------动态列----->
        <el-table-column v-for="(item, index) in tableLabel" :key="index" :align="item.align" :prop="item.prop"
          :width="item.minWidth" :label="item.label">
        </el-table-column>
        <el-table-column align="center" label="操作" fixed="right" :width="operateWidth" v-if="operateButtons.length > 0">
          <template #default="{ row }">
            <span v-for="(item, index) in operateButtons" :key="index">
              <span v-if="item.mode">
                <span v-if="item.mode.includes(mode)">
                  <el-button :type="item.type || 'primary'" :icon="item.icon" text :disabled="item.disabled"
                    @click="emitButtonKey(row, item.key)" class="operate-button">{{ item.name }}
                  </el-button>
                </span>
              </span>
              <template v-else-if="item.dynamicShow">
                <el-button :type="item.type || 'primary'" :icon="item.icon" text v-if="item.dynamicShow(row, mode)"
                  @click="emitButtonKey(row, item.key)" class="operate-button">{{ item.name }}
                </el-button>
              </template>

              <template v-else-if="item.dynamicDiable">
                <el-button :type="item.type || 'primary'" :icon="item.icon" text
                  :disabled="item.dynamicDiable(row, mode)" @click="emitButtonKey(row, item.key)"
                  class="operate-button">{{ item.name }}
                </el-button>
              </template>

              <el-button v-else :type="item.type || 'primary'" :icon="item.icon" :disabled="item.disabled" text
                @click="emitButtonKey(row, item.key)" class="operate-button">{{ item.name }}
              </el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <!------分页组件------>

      <pagination v-if="isPagination" :total="total" layout="prev, pager, next, sizes, total"
        v-model:page="queryTable.page" v-model:limit="queryTable.size" @pagination="getList(queryParams)" />
    </div>
  </div>
</template>

<script setup name="hTable">
import { changSortNumber } from "@/api/other.js";
import listFunctions from "@/api/tableList";
import { getCurrentInstance, ref, computed, watch, onMounted } from "vue";
const { proxy } = getCurrentInstance();
const emit = defineEmits(["alink", "emitTopButton", "emitButtonKey"]);
const props = defineProps({
  tableIndex: {
    type: Boolean,
    default: true,
  },
  // 是否展示合计行
  isShowSummary: {
    type: Boolean,
    default: false,
  },
  // 是否使用Card样式
  isNeedCard: {
    type: Boolean,
    default: false,
  },
  tableProps: {
    type: Array,
    default: () => [],
  },
  topButtons: {
    type: Array,
    default: () => [],
  },
  tableHeight: {
    type: Number,
    default: 520,
  },
  isPagination: {
    type: Boolean,
    default: true,
  },
  isMultify: {
    type: Boolean,
    default: false,
  },
  showRightButtons: {
    type: Boolean,
    default: false,
  },
  operateButtons: {
    type: Array,
    default: () => [],
  },
  functionKey: {
    type: String,
    required: true,
  },
  mode: {
    type: String,
    default: "edit",
  },
  buttonWidth: {
    type: Number,
    default: 160,
  },
  rowData: {
    type: Object,
    default: () => ({}),
  },
});
let loading = ref(false);
let workTodoData = ref([]);
let total = ref(0);
let queryParams = ref({});
const queryTable = ref({ page: 1, size: 10 });
const multipleSelection = ref([]);

let newTableProps = ref([]);
let drawer = ref(false); // 控制列显示与隐藏
let tableLabel = ref([]);
let inputText = ref({});
newTableProps.value = [...props.tableProps];

const operateWidth = computed(() => {
  const buttons = props.operateButtons.filter((item) => {
    if (item.mode) {
      return item.mode.includes(props.mode);
    }
    if (item.dynamicShow) {
      return false;
    }
    return true;
  });
  if (buttons.length == 0) {
    buttons.length = 1;
  }
  console.log("props.buttonWidth", props.buttonWidth);
  console.log(buttons.length * props.buttonWidth);
  return buttons.length * props.buttonWidth;
});

function showDrawer() {
  drawer.value = true;
}

function handleBlur(row, prop) {
  changSortNumber({
    idAssigned: row["idAssigned"],
    projTerminalGroupId: props.rowData.id,
    ranking: row[prop],
  }).then((res) => {
    if (res.code == 200) {
      getList(queryParams.value);
    } else {
      proxy.$modal.msgError(res.message);
    }
  });
}
// 处理表格多选的情况
function handleSelectionChange(val) {
  multipleSelection.value = val;
}

// 如果有a链接向外抛出
function handleClick(row, key) {
  emit("alink", {
    key,
    rowData: row,
  });
}

// 获取项目列表
function getList(qp, buttonSearch = false) {
  console.log('qp', qp);
  newTableProps.value = [...props.tableProps];
  loading.value = true;
  queryParams.value = qp;
  if (buttonSearch) {
    queryTable.value.page = 1;
  }
  console.log("queryTable.value", queryTable.value);
  const parmas = props.isPagination
    ? { ...queryParams.value, ...queryTable.value }
    : { ...queryParams.value };
  console.log('params', parmas);
  listFunctions[props.functionKey](parmas)
    .then((res) => {
      if (res.success) {
        if (res.data) {
          workTodoData.value =
            res.data.records || res.data.list || res.data || [];
          total.value = res.data.totalCount || res.data.total || 0;
        } else {
          workTodoData.value = [];
        }
      } else {
        workTodoData = [];
        proxy.$modal.msgError("获取数据失败，" + res.message);
      }
      loading.value = false;
    })
    .catch((error) => {
      // proxy.$modal.msgSuccess("接口异常，获取数据失败!" + error);
      workTodoData = [];
      loading.value = false;
    });
}

function headerCellStyle() {
  return {
    "border-color": "#869fbb",
  };
}

// 内容单元格样式
const cellStyle = () => {
  return {
    "border-color": "#869fbb",
  };
};
// 向父级组件抛出数据
function emitMethod(key, params) {
  let ids = [];
  if (params === "multiple") {
    ids = multipleSelection.value;
  }
  emit("emitTopButton", {
    key,
    ids,
  });
}

function emitButtonKey(row, key) {
  emit("emitButtonKey", {
    key,
    rowData: row,
  });
}

/**
 * 动态根据表格内容设置表头的宽度以及表格单列宽度
 * @param {Object} 当前行的数据内容
 * @param {Array} data 表格数据
 * return 的内容如果没有实际宽度，只能return,不可以带上具体的数值 否则表格宽度会撑不满
 */
function tableSetThWidth({ labelName, prop }, data) {
  // 表格数据为空，且表头的选项不多的情况下，就默认平铺
  if (!data || data.length == 0) return;

  let index = 0,
    columnContent = "";
  for (let i = 0; i < data.length; i++) {
    if (data[i][prop] === null) continue;
    const now_temp = data[i][prop] + "",
      max_temp = data[index][prop] + "";
    if (now_temp.length > max_temp.length) index = i;
  }
  columnContent = data[index][prop] + ""; // 获取数据长度最长的数据
  if (!columnContent) return labelName.length * 22 + 30; //表格某个字段没有数据的情况

  let flexWidth = 0;
  for (let char of columnContent) {
    //获取当前列所在文本最长为当前列宽度
    if ((char >= "A" && char <= "Z") || (char >= "a" && char <= "z")) {
      //英文字符【英文字符默认给了8个字符，如果全为大写的情况，会展示不全】
      flexWidth += 5;
    } else if (char >= "\u4e00" && char <= "\u9fa5") {
      //中文字符
      flexWidth += 14;
    } else {
      //其他字符
      flexWidth += 10;
    }
  }
  let labelLen = 0;
  labelLen = labelName.length * 22 + 30;
  if (flexWidth < 100) flexWidth = 100; // 设置最小宽度
  if (flexWidth < labelLen) flexWidth = labelLen; // 最小宽度平铺不开替换
  return flexWidth;
}
// 向父组件暴露方法和数据
defineExpose({
  getList,
});
</script>

<style lang="scss" scoped>
.alink-color {
  color: #0503aa !important;
}

.top-buttons {
  float: left;
  padding-bottom: 6px;
}

.right-buttons {
  float: right;
  margin-bottom: 5px;
}

.operate-button {
  margin-right: 0;
}

.h-card {
  border-radius: 4px;
  border: 1px solid #e6ebf5;
  background-color: #ffffff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  padding: 20px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-top: 10px;
}

.h-table {
  padding-bottom: 8px;
}

:deep .pagination-container .el-pagination {
  right: 14px;
}

.h-table {
  :deep(.el-table) {
    border: 1px solid #869fbb;
    border-collapse: collapse;

    tr {
      background-color: #f5f5f5;
    }

    td {
      color: #000;
    }
  }

  :deep(.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell) {
    background-color: whitesmoke;
  }
}

:deep(.el-table--large) .el-table__cell {
  padding: 6px 0 !important;
}
</style>
